/**
 * Photograph size, and the short burst a capture chooses from.
 *
 * The buffer no longer has to hold seconds of framing — the eraser needs one
 * frame — so it holds a fraction of a second at full size, and the capture
 * takes the sharpest frame in it. A shutter press shakes the phone; the frame
 * under the thumb is rarely the best one.
 */

export type QualityName = 'fast' | 'balanced' | 'max';

export interface Quality {
  name: QualityName;
  label: string;
  /** Longest edge of the photograph, in pixels; capped by what the camera delivers. */
  longEdge: number;
  /** Frames held for choosing the sharpest. */
  frames: number;
  /** Milliseconds between them. */
  interval: number;
}

/**
 * Six frames at full size is about 50 MB at 1920 on the long edge, which every
 * phone this app can run on carries without flinching.
 */
export const QUALITY: Record<QualityName, Quality> = {
  fast: { name: 'fast', label: 'Fast', longEdge: 1280, frames: 5, interval: 120 },
  balanced: { name: 'balanced', label: 'Balanced', longEdge: 1920, frames: 6, interval: 110 },
  max: { name: 'max', label: 'Maximum', longEdge: 2560, frames: 6, interval: 110 },
};

/** How many of the newest frames a shutter press chooses between. */
export const BURST = 4;
